<template>
  <div class="base-app">
    <update-prompt @logout="onLogout"></update-prompt>

    <nav-drawer
      :show="showDrawer"
      @input="showDrawer = $event"
      @logout="onLogout"
    />

    <app-bar @hamb-click="showDrawer = !showDrawer"></app-bar>

    <v-content>
      <RouterView :key="$router.fullPath" />
    </v-content>
  </div>
</template>

<script>
  import { mapActions, mapMutations } from "vuex";

  import UpdatePrompt from "@/components/UpdatePrompt.vue";

  export default {
    name: "BaseApp",
    components: {
      NavDrawer: () => import("@/components/NavDrawer.vue"),
      AppBar: () => import("@/components/AppBar.vue"),
      UpdatePrompt
    },
    data() {
      return {
        showDrawer: false
      };
    },
    methods: {
      ...mapMutations({
        setConnectionStatus: "setConnectionStatus",
        setSnackbar: "setSnackbar"
      }),

      ...mapActions({
        logout: "auth/logout",
        cleanAll: "cleanAll"
      }),

      // Perform logout
      async onLogout() {
        await this.logout();
        await this.cleanAll();
        this.$router.push({ name: "LoginPage" });
      },

      checkUpdates() {
        // let root = this;

        console.log("Checking updates....");

        navigator.serviceWorker
          .getRegistrations()
          .then(function(registrations) {
            for (var i = 0; i < registrations.length; i++) {
              console.log("registration found : asking for update");
              registrations[i].update();
            }
          });
      }
    },
    mounted() {
      this.checkUpdates();
    }
  };
</script>

<style></style>
